import { byTypeName } from '@InstanceFactory';

export const ORIGIN_PROPS = Symbol('ORIGIN_PROPS');

const isLocalizedString = (value: any): value is [string, string] => _.isArray(value) && value.length === 2;

export function localizeProperty(obj: { $type: string; [ORIGIN_PROPS]?: object }, key: string, value: any): any {
    const { localizable = [] } = byTypeName(obj.$type) ?? {};
    if (localizable.contains(key)) {
        if (isLocalizedString(value)) {
            const [orig, local] = value;
            obj[ORIGIN_PROPS] = { ...{ [key]: orig }, ...obj[ORIGIN_PROPS] };
            return local;
        }
        if (_.isPlainObject(value)) {
            const origValue = {};
            obj[ORIGIN_PROPS] = { ...{ [key]: origValue }, ...obj[ORIGIN_PROPS] };
            for (const [innerKey, innerValue] of Object.entries(value)) {
                if (isLocalizedString(innerValue)) {
                    const [orig, local] = innerValue;
                    origValue[innerKey] = orig;
                    value[innerKey] = local;
                }
            }
        }
    }
    return value;
}

export function delocalize(val: { [ORIGIN_PROPS]?: any }): void {
    if (Object.isObject(val) && ORIGIN_PROPS in val) {
        const originProps = val[ORIGIN_PROPS];
        for (const [prop, value] of Object.entries(originProps)) {
            if (_.isPlainObject(value)) {
                val[prop] = val[prop] ?? {};
                for (const [key, string] of Object.entries(value)) {
                    val[prop][key] = string;
                }
            } else {
                val[prop] = value;
            }
        }
    }
}
